import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import { serializer } from './serializer';

bus.on(constants.EVENTS.COUPON.LIST_ALL.REFRESH, () => {
  const requestId = 'listAllCoupons-' + Date.now();
  bus.emit(constants.EVENTS.COUPON.LIST_ALL.REFRESHING);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.COUPON.GET_LIST,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        bus.emit(constants.EVENTS.COUPON.LIST_ALL.REFRESHED, parsed.data);
      } else {
        bus.emit(constants.EVENTS.COUPON.LIST_ALL.REFRESH_ERROR, parsed);
      }
    }
  });
});

bus.on(constants.EVENTS.COUPON.UPDATE, saveCoupon);
bus.on(constants.EVENTS.COUPON.SUBMIT, saveCoupon);
bus.on(constants.EVENTS.COUPON.DELETE, (data) =>
  saveCoupon({ ...data, action: 'delete' })
);
bus.on(constants.EVENTS.COUPON.UPDATE_SETTINGS, saveSettings);

async function saveSettings(settings) {
  const requestId = 'saveCouponSettings-' + Date.now();
  const store = getStore('coupon');
  const couponsData = store?.state?.list_all || {};

  bus.emit(constants.EVENTS.LOADING.START);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.COUPON.UPDATE,
    method: 'POST',
    data: serializer.serializeSettings(settings, couponsData)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      bus.emit(constants.EVENTS.LOADING.FINISH);
      if (parsed.success) {
        bus.emit(constants.EVENTS.COUPON.UPDATED, parsed.data);
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Succès',
          body: 'Paramètres des coupons mis à jour'
        });
        bus.emit(constants.EVENTS.COUPON.LIST_ALL.REFRESH);
      } else {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Erreur',
          body: parsed.message || 'Erreur lors de la mise à jour'
        });
      }
    }
  });
}

async function saveCoupon(data) {
  const requestId = 'saveCoupon-' + Date.now();
  const store = getStore('coupon');
  const couponsData = store?.state?.list_all

  bus.emit(constants.EVENTS.LOADING.START);
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url: constants.ENDPOINTS.COUPON.UPDATE,
    method: 'POST',
    data: serializer.serialize(data, couponsData)
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      bus.emit(constants.EVENTS.LOADING.FINISH);
      if (parsed.success) {
        bus.emit(constants.EVENTS.COUPON.UPDATED, parsed.data);
        bus.emit(constants.EVENTS.COUPON.LIST_ALL.REFRESH, parsed.data);
      } else {
        bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
          title: 'Echec de sauvegarde',
          body: parsed.message
        });
        bus.emit(constants.EVENTS.COUPON.UPDATED, parsed);
        bus.emit(constants.EVENTS.COUPON.LIST_ALL.REFRESH, parsed);
      }
    }
  });
}
